import React from 'react';
import { useAPIContext } from '../../../../context/api';
import { BrandsAPI } from '../../../../../../constructs/brands/interface';

export const useCreatePromptBanner = () => {
  const { callEndpoint } = useAPIContext();

  const createPromptBanner = React.useCallback(
    async (prompt: string, clientName?: string) => {
      try {
        const res = await callEndpoint<BrandsAPI, 'create-ai-banner'>('brands', '/banners', 'POST', {
          prompt,
          ...(clientName && { clientName })
        });

        if (!res) throw new Error('Respuesta del servidor inesperada');

        return res;
      } catch (error: any) {
        console.error('Error al crear asset:', error);
        return null;
      }
    },
    [callEndpoint]
  );

  return { createPromptBanner };
};
